import type { IconData } from '@stacksjs/iconify-core'

export const flickr: IconData = {
  "body": "<g fill=\"currentColor\"><circle cx=\"4.727\" cy=\"4.757\" r=\"4.727\"/><circle cx=\"15.255\" cy=\"4.757\" r=\"4.727\"/></g>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default flickr
